/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LanguageCefrLevel {
  A1 = "A1",
  A2 = "A2",
  B1 = "B1",
  B2 = "B2",
  C1 = "C1",
  C2 = "C2",
}

export const LanguageCefrLevelDisplay: Record<LanguageCefrLevel, string> = {
  [LanguageCefrLevel.A1]: "A1",
  [LanguageCefrLevel.A2]: "A2",
  [LanguageCefrLevel.B1]: "B1",
  [LanguageCefrLevel.B2]: "B2",
  [LanguageCefrLevel.C1]: "C1",
  [LanguageCefrLevel.C2]: "C2",
};
